module.exports = __webpack_public_path__ + "media/images/lps-trip-ee00ea59.png";